import { Html } from '@mv/ui-kit/primitives';
import { replacePlaceholders } from '../replacePlaceholders';
import type { RichTextContext } from '../RichText';
import { CtaTileIllustration } from './CtaTileIllustration';
import { CtaTileLink } from './CtaTileLink';
export type CtaTileLink = {
	label?: string | null;
	custom?: string | null;
	internal?: { value?: { slug?: string | null } | number | null } | null;
};

export type CtaTilesFields = {
	blockType: 'ctaTiles';
	tiles?: Array<{
		id?: string | number;
		link?: CtaTileLink;
		illustration?: { url?: string | null } | number | null;
	}>;
};

export function CtaTiles({ fields, context }: { fields: CtaTilesFields; context: RichTextContext }) {
	const tiles = fields.tiles ?? [];
	if (tiles.length === 0) return null;

	return (
		<Html.Div className="my-1 flex w-full flex-row flex-wrap gap-2 self-stretch native:min-w-full native:flex-col native:self-stretch web:flex-col web:min-[600px]:flex-row">
			{tiles.map((tile, index) => {
				const href = replacePlaceholders(resolveTileHref(tile.link) ?? '', context.replacements);
				const illustration = typeof tile.illustration === 'object' ? tile.illustration?.url : undefined;
				const label = tile.link?.label;
				if (!href || !label) return null;
				const link = context.resolveLink({
					node: undefined,
					href,
					linkType: typeof tile.link?.internal === 'object' && tile.link.internal ? 'internal' : 'custom',
					slug:
						typeof tile.link?.internal?.value === 'object' ? (tile.link.internal.value?.slug ?? undefined) : undefined,
					label,
				});

				return (
					<CtaTileLink
						key={tile.id ?? `${href}-${index}`}
						href={link.href}
						onPress={link.onPress}
						accessibilityLabel={link.accessibilityLabel ?? label}
						hrefAttrs={link.target || link.rel ? { target: link.target, rel: link.rel } : undefined}
					>
						{illustration && <CtaTileIllustration uri={illustration} />}
						<Html.Span className="font-display text-base font-bold text-white uppercase">{label}</Html.Span>
					</CtaTileLink>
				);
			})}
		</Html.Div>
	);
}

export function resolveTileHref(link: CtaTileLink | undefined) {
	if (!link || typeof link !== 'object') return undefined;
	if ('custom' in link && typeof link.custom === 'string' && link.custom) return link.custom;
	if (
		'internal' in link &&
		typeof link.internal === 'object' &&
		link.internal?.value &&
		typeof link.internal.value === 'object'
	) {
		return link.internal.value.slug ?? undefined;
	}
	return undefined;
}
